import React, { FC, memo, MouseEvent, useContext } from "react";
import { List, ListItem, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { remove } from "lodash";
import { FiltersContext } from "../../context";
import Header from "../Common/Header";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: "0.8rem",
  },
  list: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    paddingBottom: 0,
  },
  listItemUnselected: {
    width: "auto",
    margin: "0 4px 4px 0",
    padding: "8px 24px",
    color: theme.palette.secondary.dark,
    backgroundColor: theme.palette.background.default,
    "&:hover": {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  listItemSelected: {
    width: "auto",
    margin: "0 4px 4px 0",
    padding: "8px 24px",
    color: theme.palette.background.default,
    backgroundColor: theme.palette.secondary.dark,
    "&:hover": {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

interface NavigationListProps {
  title: string;
  section: string;
  options: string[];
}

const NavigationList: FC<NavigationListProps> = memo(({ section, options, title }) => {
  const classes = useStyles();

  const [filtersContext, setFiltersContext] = useContext(FiltersContext);

  const handleSelect = (e: MouseEvent<HTMLElement>, filter) => {
    const isAlreadySelected = filtersContext[section].includes(filter);

    const newFilters = isAlreadySelected
      ? remove(filtersContext[section], (value) => value !== filter)
      : [...filtersContext[section], filter];

    setFiltersContext({
      ...filtersContext,
      [section]: newFilters,
    });
  };

  return (
    <div className={classes.container}>
      {!!title && <Header title={title} variant="h4" />}
      <List className={classes.list}>
        {options.map((filter) => {
          const isSelected = filtersContext[section].includes(filter);

          return (
            <ListItem
              key={filter}
              button
              className={isSelected ? classes.listItemSelected : classes.listItemUnselected}
              onClick={(e) => handleSelect(e, filter)}
            >
              <Typography variant="body2">{filter}</Typography>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
});

export default NavigationList;
